import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './HowItWorks.module.css';

function HowItWorks() {
  const { t } = useTranslation();
  return (
    <section id="how-it-works" className={styles.section}>
      <h2 className={styles.heading}>{t('howItWorks.heading')}</h2>
      <p className={styles.subheading}>
        {t('howItWorks.subheading')}
      </p>

      <div className={styles.steps}>
        <div className={styles.step}>
          <span className={styles.badge}>1</span>
          <h3>{t('howItWorks.step1Title')}</h3>
          <p>{t('howItWorks.step1Desc')}</p>
        </div>
        <div className={styles.step}>
          <span className={styles.badge}>2</span>
          <h3>{t('howItWorks.step2Title')}</h3>
          <p>{t('howItWorks.step2Desc')}</p>
        </div>
        <div className={styles.step}>
          <span className={styles.badge}>3</span>
          <h3>{t('howItWorks.step3Title')}</h3>
          <p>{t('howItWorks.step3Desc')}</p>
        </div>
        <div className={styles.step}>
          <span className={styles.badge}>4</span>
          <h3>{t('howItWorks.step4Title')}</h3>
          <p>{t('howItWorks.step4Desc')}</p>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;

